module.exports = __webpack_public_path__ + "img/55.039fdd5a.jpg";